<p><strong>Add Random Shapes</strong></p>

<h3-horizontal-form [labelWidth]="2">
  <h3-horizontal-form-row>
    <mat-form-field>
      <mat-label>Type</mat-label>
      <mat-select multiple [(ngModel)]="selectedTypes">
        <mat-option *ngFor="let type of types" [value]="type">
          {{ type }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </h3-horizontal-form-row>
  <h3-horizontal-form-row>
    <span label>Number</span>
    <input [(ngModel)]="numShapes" type="number" class="form-control" />
  </h3-horizontal-form-row>
  <h3-horizontal-form-row>
    <span label>Max points</span>
    <input [(ngModel)]="maxPoints" type="number" class="form-control" />
  </h3-horizontal-form-row>
  <h3-horizontal-form-row>
    <span label>% key locations</span>
    <div class="input-group">
      <span class="form-control">
        <input
          [(ngModel)]="percentKeyLocations"
          type="range"
          min="1"
          max="100"
        />
      </span>
      <span class="input-group-addon">{{ percentKeyLocations }}</span>
    </div>
  </h3-horizontal-form-row>
  <h3-horizontal-form-row *ngIf="selectedTypes.includes('rectangle')">
    <span label>% ML extrapolation</span>
    <div class="input-group">
      <span class="form-control">
        <input
          [(ngModel)]="percentMLExtrapolation"
          type="range"
          min="1"
          max="100"
        />
      </span>
      <span class="input-group-addon">{{ percentMLExtrapolation }}</span>
    </div>
  </h3-horizontal-form-row>
  <h3-horizontal-form-row>
    <button class="btn btn-default" (click)="add()">Add</button>
  </h3-horizontal-form-row>
  <h3-horizontal-form-row>
    <button class="btn btn-default" (click)="selectRandomSubpoints()">
      Select random subpoints
    </button>
  </h3-horizontal-form-row>
</h3-horizontal-form>
